<template>
  <div class="bill-root">
    <div class="query-container">
      <div class="query-left">
        <el-date-picker v-model="startDate" value-format="yyyy-MM-dd" type="date" size="medium" placeholder="选择起始日期"
          @change="query" style="width: 160px" />
        至
        <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd" size="medium" placeholder="选择截至日期"
          @change="query" style="margin-left: 10px; width: 160px" />
        <el-select v-model="providerId" clearable size="medium" placeholder="请选择服务商" style="margin-left: 10px"
          @change="query">
          <el-option v-for="item in providerOpts" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <el-select v-model="status" clearable size="medium" placeholder="请选择状态" style="margin-left: 10px; width: 160px"
          @change="query">
          <el-option v-for="item in statusOpts" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="serviceType" clearable size="medium" placeholder="请选择服务类型"
          style="margin-left: 10px; width: 160px" @change="query">
          <el-option v-for="item in serviceTypeOpts" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="serviceProjs" multiple size="medium" placeholder="请选择项目"
          style="margin-left: 10px; width: 200px" @change="query">
          <el-option v-for="item in serviceProjOpts" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
        <el-input v-model="keyword" size="medium" placeholder="司机编号或车牌号或创建人" clearable
          style="width: 220px; margin-left: 10px" />
        <el-button size="medium" style="margin-left: 10px" @click="query">查询</el-button>
      </div>
      <div class="query-actions">

        <el-button type="primary" size="medium" icon="el-icon-plus" @click="openCreateBillDialog">创建工单</el-button>
      </div>
    </div>

    <el-table :data="list" border style="width: 100%" max-height="700" show-summary :summary-method="getSummaries">
      <el-table-column label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="100">
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormat('MM-dd hh:mm') }}
        </template>
      </el-table-column>
      <el-table-column label="服务时间" prop="serviceDate" width="100">
        <template slot-scope="scope">
          {{ scope.row.serviceDate | dateFormat('MM-dd hh:mm') }}
        </template>
      </el-table-column>
      <el-table-column label="服务商" prop="providerName" width="130"> </el-table-column>
      <el-table-column label="服务类型" width="120">
        <template slot-scope="scope">
          {{ transeferIdNames(scope.row.serviceType) }}
        </template>
      </el-table-column>
      <el-table-column label="项目" width="100">
        <template slot-scope="scope">
          {{ scope.row.serviceProjs | serviceProjName(allServiceProjs) }}
        </template>
      </el-table-column>
      <el-table-column prop="staffName" label="检修员" width="80"> </el-table-column>
      <el-table-column prop="vehicleNo" label="车牌号" width="120"></el-table-column>
      <el-table-column prop="driverNo" label="司机" width="160">
        <template slot-scope="scope">
          {{ scope.row.driverNo }} {{ scope.row.driverName }}
        </template>
      </el-table-column>
      <el-table-column label="费用(元)" width="80" prop="amount">
        <template slot-scope="scope">
          {{ scope.row.amount ? scope.row.amount / 100 : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="服务状态">
        <template slot-scope="scope">
          {{ getBillStatusLabel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          {{ getBillAuditLabel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="cbyName" label="创建人">
        <template slot-scope="scope">
          {{ scope.row.cbyName ?? "系统" }}
        </template>
      </el-table-column>

      <el-table-column prop="createReason" label="创建原因" width="160">
        <template slot-scope="scope">
          {{ scope.row.createReason }} - {{ scope.row.importantTips }}
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="备注" width="160"></el-table-column>
      <el-table-column prop="rejectReason" label="驳回原因" width="160"></el-table-column>
      <el-table-column label="操作" width="180" fixed="right" align="left">
        <template slot-scope="scope">
          <div class="table-actions">
            <el-link v-if="scope.row.status == 0" type="primary" :underline="false"
              @click="serviceBill(scope.row)">送检</el-link>
            <el-link v-if="scope.row.status < 10" type="primary" :underline="false"
              @click="modifyBill(scope.row)">修改</el-link>
            <el-link v-if="scope.row.status < 10 || scope.row.status === 31" type="danger" :underline="false"
              @click="deleteBill(scope.row)">删除</el-link>
            <el-link type="primary" :underline="false" @click="viewBill(scope.row)">详情</el-link>
            <el-link v-if="canPrintBill(scope.row)" type="primary" :underline="false"
              @click="printBill(scope.row)">打印</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 侧边栏 -->
    <el-dialog title="单据详情" :visible.sync="showBillDialog">
      <billDetail :bill-id="currentBill.id" v-if="!!currentBill"></billDetail>

      <!-- 弹出框 -->
      <el-dialog title="驳回原因" width="30%" :visible.sync="showRemarkDialog" append-to-body>
        <el-input v-model="remark" placeholder="请输入驳回原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showRemarkDialog = false">取消</el-button>
          <el-button @click="doAuditBillNotPass">确定</el-button>
        </span>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="currentBill && (currentBill.status == 10 || currentBill.status == 20)" type="primary"
          @click="auditBillPass(currentBill)">通过</el-button>
        <el-button v-if="currentBill && (currentBill.status == 10 || currentBill.status == 20)" type="danger"
          @click="auditBillNotPass(currentBill)">不通过</el-button>
        <el-button @click="(showBillDialog = false), (currentBill = null)">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改信息" :visible.sync="formVisible" width="600px" max-height="700" :size="size"
      :close-on-click-modal="false">
      <el-form ref="form" :model="form" :size="size" label-width="140px" inline>
        <el-form-item label="车牌号：" prop="vehicleNo" clearable>
          <el-input v-model="form.vehicleNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="司机：" prop="driverName" clearable>
          <el-input v-model="form.driverName" disabled></el-input>
        </el-form-item>
        <el-form-item label="司机编号：" prop="driverNo" clearable>
          <el-input v-model="form.driverNo" disabled></el-input>
        </el-form-item>

        <el-form-item label="时间：" prop="billDate">
          <el-date-picker style="width: 200px" v-model="form.billDate" type="date" clearable
            value-format="yyyy-MM-dd hh:mm" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="modifyDate">保 存</el-button>
        <el-button type="info" :size="size" @click="formVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 创建工单弹框 -->
    <el-dialog title="创建工单" :visible.sync="showCreateBillDialog" width="880px" class="create-bill-dialog-wrap"
      :close-on-click-modal="false" @close="closeCreateBillDialog">
      <div class="create-bill-dialog">
        <el-form label-width="100px" size="small" class="create-bill-head-form">
          <el-form-item label="服务类型">
            <el-select v-model="createBillForm.serviceType" placeholder="请选择服务类型" style="width: 100%"
              @change="onCreateBillServiceTypeChange">
              <el-option v-for="item in serviceTypeOpts" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="车辆">
            <div class="vehicle-search">
              <el-input v-model="createBillForm.vehicleKeyword" placeholder="司机编号/手机号/车牌号" clearable
                class="vehicle-keyword-input" @keyup.enter.native="searchVehicleForCreateBill" />
              <el-button type="primary" :loading="createBillVehicleLoading" @click="searchVehicleForCreateBill">
                查询车辆
              </el-button>
            </div>
          </el-form-item>
        </el-form>

        <template
          v-if="createBillForm.vehicleInfo && createBillForm.vehicleInfo.vehicleNo && createBillForm.serviceType">
          <div class="create-bill-form-wrap">
            <create-bill :key="createBillForm.formKey" :vehicle-info="createBillForm.vehicleInfo"
              :service-type="createBillForm.serviceType" @billChange="onCreateBillChange" />
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listServiceBill,
  toService,
  auditBillStatus,
  getServiceScopes,
  deleteBillInfo,
  changeProviderBillDate,
  getPartnerProviderList,
  getServiceProjs,
  listVehicleInfo,
  createServiceBillInfo
} from "@/api/partner_admin";
import { DateUtil } from "@/util";
import billDetail from "../bill_detail";
import createBill from "../mtc/create-bill";

export default {
  name: "serviceList",
  components: {
    billDetail,
    createBill
  },

  computed: {
    serviceProjOpts() {
      if (this.serviceType == "repair") {
        return this.repairProjs;
      } else if (this.serviceType == "vme") {
        return this.vmeProjs;
      } else if (this.serviceType == "consumables") {
        return this.consumablesProjs;
      } else {
        return [];
      }
    },

    allServiceProjs() {
      return this.repairProjs.concat(this.vmeProjs).concat(this.consumablesProjs);
    }
  },

  filters: {
    serviceProjName(values, allServiceProjs) {
      if (values) {
        const nameMap = allServiceProjs.reduce((acc, item) => {
          acc[item.value] = item.name;
          return acc;
        }, {});
        return values.map((item) => nameMap[item]).join(",");
      }
      return "";
    }
  },

  data() {
    return {
      serviceScopeObjs: [],
      statusOpts: [
        { label: "待办", value: "0" },
        { label: "待审", value: "1" },
        { label: "未通过", value: "2" },
        { label: "已通过", value: "3" }
      ],
      serviceTypeOpts: [
        { label: "洗车", value: "wash" },
        { label: "维修", value: "repair" },
        { label: "保养", value: "maintenance" },
        { label: "检查", value: "inspection" },
        { label: "定损", value: "assess" },
        { label: "车载维护", value: "vme" },
        { label: "损耗件更换", value: "consumables" }
      ],
      providerOpts: [],

      list: [],
      remark: null,
      showBillDialog: false,
      showRemarkDialog: false,
      currentBill: null,
      startDate: null,
      endDate: null,
      status: null,
      serviceType: null,
      serviceProjs: [],
      providerId: null,
      keyword: "",
      formVisible: false,
      form: {},
      size: "small",
      repairProjs: [],
      vmeProjs: [],
      consumablesProjs: [],
      showCreateBillDialog: false,
      createBillVehicleLoading: false,
      createBillForm: {
        serviceType: "",
        vehicleKeyword: "",
        vehicleInfo: null,
        formKey: 0
      }
    };
  },
  mounted() {
    this.initPage();
    this.query();
  },
  methods: {
    initPage() {
      this.endDate = DateUtil.getDayStr(15);
      this.startDate = DateUtil.format(new Date(), "yyyy-MM") + "-01";
      getServiceScopes().then((res) => {
        this.serviceScopeObjs = res.data || [];
      });

      getPartnerProviderList().then((res) => {
        const data = res.data || {};
        this.providerOpts = data.providers || [];
      });

      getServiceProjs().then((rs) => {
        const data = rs.data || {};
        this.repairProjs = data.repair || [];
        this.vmeProjs = data.vme || [];
        this.consumablesProjs = data.consumables || [];
      });
    },

    query() {
      listServiceBill(
        this.providerId,
        this.startDate,
        this.endDate,
        this.status,
        this.serviceType,
        this.keyword,
        this.serviceProjs
      ).then((res) => {
        this.list = res.data || [];
      });
    },

    printBill(bill) {
      window.open(
        this.$router.resolve({
          path: "/partner/bill/print",
          query: { id: bill.id, billType: bill.serviceType }
        }).href,
        "_blank"
      );
    },

    transeferIdNames(serviceType) {
      if (!serviceType) {
        return "";
      }

      for (var i = 0; i < this.serviceScopeObjs.length; i++) {
        if (this.serviceScopeObjs[i].value == serviceType) {
          return this.serviceScopeObjs[i].label;
        }
      }
      return "";
    },
    getBillStatusLabel(bill) {
      return bill.status < 10 ? "待办" : "已办";
    },
    getBillAuditLabel(bill) {
      if (bill.status < 10) {
        return "-";
      } else if (bill.status == 31) {
        return "不通过";
      } else if (bill.status == 30) {
        return "通过";
      } else {
        return "待审";
      }
    },
    viewBill(bill) {
      this.showBillDialog = true;
      this.currentBill = bill;
    },
    auditBillPass(bill) {
      this.$confirm("确定要通过该单据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        auditBillStatus([bill.id], bill.providerId, 30).then(() => {
          bill.status = 30;
          this.showBillDialog = false;
          this.currentBill = null;
        });
      });
    },
    auditBillNotPass() {
      this.showRemarkDialog = true;
      this.remark = null;
    },
    doAuditBillNotPass() {
      let me = this;
      let bill = this.currentBill;
      let rejectReason = this.remark;
      auditBillStatus([bill.id], bill.providerId, 31, rejectReason).then(() => {
        bill.status = 31;
        me.showRemarkDialog = false;
        me.showBillDialog = false;
        me.currentBill = null;
      });
    },

    modifyDate() {
      const param = {
        id: this.form.id,
        billDate: this.form.billDate
      };
      changeProviderBillDate(param).then(() => {
        this.formVisible = false;
        this.$message.success("修改成功");
        this.query();
      });
    },

    serviceBill(bill) {
      this.$confirm("确定要送检吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        toService(bill.id).then(() => {
          bill.status = 2;
        });
      });
    },

    modifyBill(bill) {
      this.form = { ...bill };
      this.formVisible = true;
    },

    deleteBill(bill) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteBillInfo(bill.id).then(() => {
          let idx = -1;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].id == bill.id) {
              idx = i;
              break;
            }
          }
          this.list.splice(idx, 1);
        });
      });
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计：";
          return;
        }
        const property = column.property;

        if (column.property !== "amount") {
          sums[index] = "";
          return;
        }

        const values = data.map((item) => {
          return Number(item[property] / 100);
        });

        if (!values.every((value) => isNaN(value))) {
          const result = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = result ? result.toFixed(2) : 0;
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },

    canPrintBill(bill) {
      const { serviceType, status } = bill;
      const canPrintType =
        serviceType === "inspection" || serviceType === "maintenance" || serviceType === "repair";
      return canPrintType && status >= 10;
    },

    openCreateBillDialog() {
      this.createBillForm = {
        serviceType: "",
        vehicleKeyword: "",
        vehicleInfo: null,
        formKey: this.createBillForm.formKey + 1
      };
      this.showCreateBillDialog = true;
    },

    closeCreateBillDialog() {
      this.createBillForm = {
        serviceType: "",
        vehicleKeyword: "",
        vehicleInfo: null,
        formKey: 0
      };
    },

    onCreateBillServiceTypeChange() {
      this.createBillForm.vehicleInfo = null;
    },

    searchVehicleForCreateBill() {
      const keyword = (this.createBillForm.vehicleKeyword || "").trim();
      if (!keyword) {
        this.$message.warning("请输入司机编号/手机号/车牌号");
        return;
      }
      const startDate = this.startDate || DateUtil.format(new Date(), "yyyy-MM-dd");
      const endDate = this.endDate || DateUtil.format(new Date(), "yyyy-MM-dd");
      this.createBillVehicleLoading = true;
      listVehicleInfo(keyword, startDate, endDate)
        .then((res) => {
          const data = res.data || {};
          if (data.vehicleNo) {
            this.createBillForm.vehicleInfo = data;
            this.createBillForm.formKey += 1;
          } else {
            this.$message.warning("未查询到匹配的车辆");
            this.createBillForm.vehicleInfo = null;
          }
        })
        .finally(() => {
          this.createBillVehicleLoading = false;
        });
    },

    onCreateBillChange(param) {
      const { bill, action } = param;
      if (action === "save") {
        createServiceBillInfo(bill).then(() => {
          this.showCreateBillDialog = false;
          this.closeCreateBillDialog();
          this.$message.success("创建工单成功");
          this.query();
        });
      } else {
        this.showCreateBillDialog = false;
        this.closeCreateBillDialog();
      }
    }
  }
};
</script>

<style scoped>
.bill-root {
  padding: 10px;
}

.query-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 20px;
}

.query-container .query-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
}

.query-container .query-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid #dcdfe6;
  flex-shrink: 0;
}

.query-container .query-actions .el-button {
  min-width: 80px;
}

.table-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
}

.table-actions .el-link {
  font-size: 13px;
}

.table-actions .el-link+.el-link {
  margin-left: 0;
}

/* 创建工单弹框 */
.create-bill-dialog {
  padding: 0 8px;
}

.create-bill-dialog .create-bill-head-form {
  margin-bottom: 8px;
}

.create-bill-dialog .vehicle-search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.create-bill-dialog .vehicle-keyword-input {
  width: 260px;
}

.create-bill-form-wrap {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.create-bill-dialog>>>.create-bill-root {
  padding: 0;
}

.create-bill-dialog>>>.create-bill-root .bill-title {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 16px;
}
</style>

<style>
.create-bill-dialog-wrap.el-dialog {
  max-width: 90vw;
}
</style>
